import React from 'react';
import { Field } from 'redux-form/immutable';
import { fromJS } from 'immutable';

import TextInput from '../../components/form-input-text';
import SelectInput from '../../components/form-input-select';
import { CLIENT, TEAM_MEMBER, INFLUENCER } from '../../utils/static-configuration';

export default class FormInviteRow extends React.Component {
  render() {
    const { fields, touched, error, form, hasClient } = this.props;

    const options = [{ value: TEAM_MEMBER, label: 'Team member' }];
    if (hasClient) {
      options.push({ value: CLIENT, label: 'Client' });
    }
    options.push({ value: INFLUENCER, label: 'Influencer' });

    return (
      <div>
        { fields.map((collaborator, index) => (
          <div key={index}>
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6">
              <Field
                name={`${collaborator}.role`}
                component={props => (
                  <SelectInput
                    name={`${collaborator}.role`}
                    label={index === 0 ? 'Who is this person?' : ''}
                    className="stacked"
                    {...props}
                    options={options}
                  />
                )}
              />
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6">
              <Field
                name={`${collaborator}.email`}
                className="stacked"
                id="email-1"
                type="text"
                label={index === 0 ? 'Email address' : ''}
                component={TextInput}
                placeholder="email@example.com"
              />
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6">
              <Field
                name={`${collaborator}.name`}
                className="stacked"
                type="text"
                id="name-1"
                label={index === 0 ? 'Full name (optional)' : ''}
                component={TextInput}
                placeholder=""
              />
            </div>
            { form && form.getIn([index, 'role']) && form.getIn([index, 'role']) === INFLUENCER &&
              <div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6" />
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-4-6 grid-xl-4-6">
                  <Field
                    name={`${collaborator}.socialHandle`}
                    type="text"
                    className="stacked"
                    label="Social handle"
                    component={TextInput}
                    placeholder="e.g. Zoella"
                  />
                  <div className="spacer small" />
                  <p className="small light">
                    Use the social handle they are most known by. This will be the name used when collaborating with them.
                  </p>
                  {/*<div>
                    <label>Required channel data (optional) <img data-tip="If you check a channel the influencer will be required to link that social channel data with dyzio when they sign up. This will allow visibility of their analytics data." src="/icons/info.svg" alt="info" /></label>
                    <ReactTooltip effect="solid" class="custom-tooltip" />
                  </div>
                  <Field id="Facebook" className="stacked" name={`${collaborator}.facebook`} label="Facebook" component={CheckboxInput} />
                  <Field id="Twitter" className="stacked" name={`${collaborator}.twitter`} label="Twitter" component={CheckboxInput} />
                  <Field id="Youtube" className="stacked" name={`${collaborator}.youtube`} label="Youtube" component={CheckboxInput} />*/}
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="break" />
                </div>
              </div>
            }
          </div>
        ))}
        <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
          <div className="hero small">
            <button className="medium wide icon" type="button" onClick={() => fields.push(fromJS({}))} >
              <p>add another</p>
              <img src="/icons/add-person.svg" alt="add another" />
            </button>
            { touched && error && <span>{error}</span> }
            <div className="spacer" />
          </div>
        </div>
      </div>
    );
  }
}

FormInviteRow.propTypes = {};



/** WEBPACK FOOTER **
 ** ./src/components/form-invite-row/index.js
 **/